import { createContainer } from 'unstated-next'
import CatalogItem, { CatalogItemContainer } from './catalogItem'
import Country, { CountryContainer } from './country'
import Discount, { DiscountContainer } from './discount'
import Lead, { LeadContainer } from './lead'
import Order, { OrderContainer } from './order'
import Upsell, { UpsellContainer } from './upsell'

type CheckoutContainer = CatalogItemContainer &
  CountryContainer &
  DiscountContainer &
  LeadContainer &
  OrderContainer &
  UpsellContainer

const useCheckout = () => {
  const catalogItem = CatalogItem.useContainer()
  const country = Country.useContainer()
  const discount = Discount.useContainer()
  const lead = Lead.useContainer()
  const order = Order.useContainer()
  const upsell = Upsell.useContainer()

  return {
    ...catalogItem,
    ...country,
    ...discount,
    ...lead,
    ...order,
    ...upsell,
  }
}

var Checkout = createContainer<CheckoutContainer>(useCheckout)

export default Checkout
